import React from 'react';
import { faTimes, faSave, faTimesCircle } from '@fortawesome/pro-light-svg-icons';
import { FloatingActionButtonBar } from '../../../../components/area-layout/floating-action-button-bar';
import { FloatingActionButton } from '../../../../components/area-layout/floating-action-button';
import { FabDivider } from '../../../../components/area-layout/fab-divider';

interface ICourseEnrollmentLaunchboxProps {
  onSave: () => void;
  onValidate: () => boolean;
  onCancelCourseEnrollment: () => void;
  isLoading: boolean;
  isReadOnly: boolean;
}

export function CourseEnrollmentLaunchbox(props: ICourseEnrollmentLaunchboxProps) {
  const { isLoading, onSave, onValidate, onCancelCourseEnrollment, isReadOnly } = props;

  function handleSave() {
    if (onValidate()) {
      onSave();
    }
  }

  return (
    <FloatingActionButtonBar>
      {!isReadOnly && (
        <>
          <FloatingActionButton loading={isLoading} buttonText="Annullér" icon={faTimesCircle} onClick={onCancelCourseEnrollment} />
          <FabDivider />
          <FloatingActionButton loading={isLoading} buttonText="Gem og luk" icon={faSave} onClick={handleSave} inverted />
        </>
      )}
      <FloatingActionButton buttonText="Luk" icon={faTimes} onClick={() => window.close()} inverted />
    </FloatingActionButtonBar>
  );
}
